var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdvStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 17v10.357A3.643 3.643 0 0117.356 31H8.644A3.643 3.643 0 015 27.357V6.644A3.644 3.644 0 018.644 3H11M5 25h16",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M15 2.5A1.5 1.5 0 0116.5 1h13A1.5 1.5 0 0131 2.5v9a1.5 1.5 0 01-1.5 1.5h-13a1.5 1.5 0 01-1.5-1.5v-9z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 10a3 3 0 100-6 3 3 0 000 6zm1.253-4.056a.476.476 0 00.033-.174v-.341h-2.618v.634h1.573l-1.55 1.88a.619.619 0 00-.09.15.39.39 0 00-.03.13v.348h2.672v-.634H22.63l1.536-1.86a.386.386 0 00.087-.133z",
    fill: "currentColor"
  })));
}
export default SvgPdvStatus;